import store from "./store";
import { ADD_TO_WISH_LIST } from "../Pages/wishListPage/store/actionTypes";
import apiSettings from "../utils/apiSettings";
import { getCookie } from "../utils/cookies";

const checkFavourInLocalStorage = () => {
    if (!getCookie("favour")) {
        return;
    }
    return JSON.parse(getCookie("favour"));
};

const getRootAttributes = () => {
    const root = document.getElementById("js-fs-search");

    const isInternal = root.dataset.searchInternal;
    const isFlex = root.dataset.searchFlex;

    return {
        ...root.dataset,
        facets: root.dataset.searchFacets.split("|").reduce((acc, c) => ({ ...acc, [c]: [] }), {}),
        query_args: {
            post_type: root.dataset.searchPostType,
            posts_per_page: root.dataset.searchPerPage,
            lang: root.dataset.searchLanguage,
            paged: 1,
            post_status: "publish",
            order: root.dataset.searchOrder,
            orderby: root.dataset.searchOrderby,
            meta_query: [
                {
                    key: "recruitee_wp_status",
                    value: isInternal === '1' ? ["published", "internal"] : "published",
                    compare: isInternal === '1' ? "OR" : "==",
                },
                isFlex === '1'
                    ? {
                        key: "recruitee_wp_employment_type",
                        value: "FLEX",
                        compare: "==",
                    }
                    : {
                        relation: 'OR',
                        [0]: {
                            key: "recruitee_wp_employment_type",
                            value: "VAST",
                            compare: "==",
                        },
                        [1]: {
                            key: "recruitee_wp_employment_type",
                            compare: "NOT EXISTS",
                        },
                        [2]: {
                            key: "recruitee_wp_employment_type",
                            value: "",
                            compare: "=",
                        }
                    },
                {
                    key: "recruitee_wp_status",
                    value: "closed",
                    compare: "!=",
                },
            ]
        },
    };
};

const setInitAppSettings = () => {
    const settings = getRootAttributes();
    apiSettings.initAPI(settings);
    store.dispatch({
        type: "[SYSTEM] BASE API SETTINGS",
        payload: settings,
    });
    store.dispatch({
        type: ADD_TO_WISH_LIST,
        payload: checkFavourInLocalStorage(),
    });
};

export default setInitAppSettings;
